import { Hint } from "@/components/devicePanel/Hint";
import { STATE_TEXT, type DevicePanelDeviceState } from "@/types/devicePanel";

/** A device's missing result as one dim line; the backend's reason, when it
 * sends one, is in the tooltip. */
export function DeviceState({
  state,
  message,
  className = "",
}: {
  state: Exclude<DevicePanelDeviceState, "completed">;
  message: string | null;
  className?: string;
}) {
  return (
    <Hint label={message}>
      <span tabIndex={message === null ? undefined : 0} className={`text-fg-dim ${className}`}>
        {STATE_TEXT[state]}
      </span>
    </Hint>
  );
}
